import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";

import FilterPanel, { PanelBody, PanelFooter } from "../../../../sharedComponents/filterPanel";
import { createFitnessJournal, editFitnessJournal, getFitnessJournalSummary, resetField } from "../../../../store/actions";
import { FormField } from "../../../../sharedComponents/formField";
import { required, isInt, maxInt } from "../../../../constants/formValidators";
import "../FitnessJournal.scss";

import enGB from "date-fns/locale/en-GB";
registerLocale("enGB", enGB);

const AddJouralExerciseForm = ({
	handleSubmit,
	createFitnessJournal,
	getFitnessJournalSummary,
	initialValues,
	resetField,
	onUpdate,
	editFitnessJournal,
	journalLogDate,
	range
}) => {
	const [journalDate, setJournalDate] = useState(
		moment(initialValues && initialValues.date ? initialValues.date : journalLogDate)._d
	);
	const [selectedExercise, setSelectedExercise] = useState("");

	useEffect(() => {
		if (initialValues && initialValues.exercise) {
			resetField("MyWorkout.toggleAddPlanPanel", false);
			setSelectedExercise(initialValues);
		}
		if (initialValues && initialValues.id) {
			setSelectedExercise(initialValues);
		}
	}, [initialValues, resetField]);

	const handleChange = (date) => {
		setJournalDate(date);
	};

	const addJournalExercise = (values) => {
		const queryValues = {
			...values,
			date: moment(journalDate).format("YYYY/MM/DD"),
			exercise: initialValues.exercise
		};
		const successHandler = (event) => {
			onUpdate && onUpdate();
			NotificationManager.success("Journal added!", "", 5000);
			moment(journalDate).isBetween(range.start_date, range.end_date) &&
				getFitnessJournalSummary(`date=${moment(journalDate).format("YYYY-MM-DD")}`);
		};
		setSelectedExercise(null);
		initialValues.id ? editFitnessJournal(queryValues, successHandler) : createFitnessJournal(queryValues, successHandler);
	};

	const renderExerciseForm = () => {
		return (
			<div className="row">
				<div className="col-6 mb-3">
					<p className="mb-0">Date</p>
					<DatePicker
						selected={journalDate}
						onChange={handleChange}
						dateFormat="yyyy-MM-dd"
						locale="enGB"
						maxDate={new Date()}
					/>
				</div>
				<Field
					label="Minutes"
					name="minutes"
					validate={[required, isInt, maxInt]}
					formGroupClass="col-12"
					component={FormField}
				/>
			</div>
		);
	};

	const renderResistanceForm = () => {
		return (
			<div className="row">
				<div className="col-6 mb-3">
					<span>Date</span>
					<DatePicker selected={journalDate} onChange={handleChange} dateFormat="yyyy-MM-dd" maxDate={new Date()} />
				</div>

				<Field
					label="Weight Lifted"
					name="weight_lifted"
					formGroupClass="col-12"
					component={FormField}
					validate={[required, isInt, maxInt]}
				/>
				<Field
					label="Amount of Reps"
					name="reps"
					formGroupClass="col-12"
					component={FormField}
					validate={[required, isInt, maxInt]}
				/>
				<Field
					label="Number of Sets"
					name="number_of_sets"
					formGroupClass="col-12"
					component={FormField}
					validate={[required, isInt, maxInt]}
				/>
			</div>
		);
	};

	const handleCancel = () => {
		setSelectedExercise(null);
		onUpdate && onUpdate();
	};

	return (
		<FilterPanel
			className="add-journal-exercise-panel hide-sub-header"
			show={selectedExercise ? true : false}
			toggle={() => handleCancel()}
			title={initialValues ? initialValues.exercise_name : "Exercise"}
			closeBtn>
			<form onSubmit={handleSubmit(addJournalExercise)} className="d-flex flex-column h-100 flex-fill">
				<PanelBody className="d-flex flex-column">
					{initialValues &&
					(initialValues.type_of_activity === "resistance" || initialValues.type_of_activity === "Resistance")
						? renderResistanceForm()
						: renderExerciseForm()}
				</PanelBody>
				<PanelFooter className="sticky-footer">
					<div className="text-right">
						<button type="button" className="btn text-primary-dark" onClick={() => handleCancel()}>
							Cancel
						</button>
						{initialValues && initialValues.id ? (
							<button type="submit" className="btn btn-primary">
								Save
							</button>
						) : (
								<button type="submit" className="btn btn-primary">
									<i className="icon icon-plus" />
									Add Now
							</button>
							)}
					</div>
				</PanelFooter>
			</form>
		</FilterPanel>
	);
};

const mapDispatchToProps = { createFitnessJournal, resetField, editFitnessJournal, getFitnessJournalSummary };

const mapStateToProps = (state) => ({ toggleAddToJournal: get(state.FitnessJournal, "toggleAddToJournal", false) });

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "AddJournalExerciseForm",
		enableReinitialize: true
	})(AddJouralExerciseForm)
);
